export default [
  '', // 0
  'Región de Tarapacá',
  'Región de Antofagasta',
  'Región de Atacama',
  'Región de Coquimbo',
  'Región de Valparaíso',
  'Región del Libertador General Bernardo O’Higgins',
  'Región del Maule',
  'Región del Biobío',
  'Región de La Araucanía',
  'Región de Los Lagos',
  'Región de Aysén del General Carlos Ibáñez del Campo',
  'Región de Magallanes y la Antártica Chilena',
  'Región Metropolitana de Santiago', // 13
  'Región de Los Ríos', // 14
  'Región de Arica y Parinacota', // 15
  'Región del Ñuble', // 16
]
